import { useCallback, useEffect, useState } from 'react';
import { listEnviosCorreo, resumenEnviosCorreo } from 'api/enviosCorreo';

const PAGE_SIZE = 25;

// El filtro por defecto muestra solo lo que requiere atención: si al abrir la
// página se ve todo, no se ve nada.
export const FILTROS_POR_DEFECTO = { estado: 'fallido,omitido' };

// Constante de módulo, no un literal inline en el default del parámetro: un
// literal inline se recrea en cada invocación del hook y cambia de identidad
// en cada render, lo que rompe las dependencias de los useCallback de abajo
// y dispara un ciclo de refetch infinito cuando el consumidor no pasa `consultas`.
const CONSULTAS_POR_DEFECTO = { listar: listEnviosCorreo, resumen: resumenEnviosCorreo };

export default function useEnviosCorreoList(
  initialFilters = FILTROS_POR_DEFECTO,
  consultas = CONSULTAS_POR_DEFECTO
) {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [resumen, setResumen] = useState({ fallidos: 0, omitidos: 0, enviados: 0 });
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [filters, setFilters] = useState(initialFilters);

  const refresh = useCallback(async () => {
    setLoading(true);
    try {
      const data = await consultas.listar({
        ...filters,
        search: search || undefined,
        limit: PAGE_SIZE,
        offset: (page - 1) * PAGE_SIZE,
      });
      setRows(Array.isArray(data?.rows) ? data.rows : []);
      setTotal(data?.total ?? 0);
    } catch {
      setRows([]);
      setTotal(0);
    } finally {
      setLoading(false);
    }
  }, [filters, search, page, consultas]);

  const refreshResumen = useCallback(async () => {
    try {
      const data = await consultas.resumen({ dias: 7 });
      setResumen({
        fallidos: data?.fallidos ?? 0,
        omitidos: data?.omitidos ?? 0,
        enviados: data?.enviados ?? 0,
      });
    } catch {
      setResumen({ fallidos: 0, omitidos: 0, enviados: 0 });
    }
  }, [consultas]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  useEffect(() => {
    refreshResumen();
  }, [refreshResumen]);

  return {
    rows,
    total,
    resumen,
    loading,
    page,
    setPage,
    pageSize: PAGE_SIZE,
    search,
    setSearch,
    filters,
    setFilters,
    refresh: async () => {
      await refresh();
      await refreshResumen();
    },
  };
}
